import { trackMenuNavigation } from '../menuAnalytics';
import * as translator from '../../../../utils/translator';
import { clientConfig } from '../../../../config';
import LanguageToggle from '../../../Headers/HeaderCMS/LanguageToggle';

interface InfoSectionProps {
  menuLinks: Array<{
    text: string;
    url: string;
    mix_panel_title?: string | null;
  }>;
  onChatWithUsClick: () => void;
  language: string;
  country: string;
}

export function InfoSection({
  menuLinks,
  onChatWithUsClick,
  language,
  country,
}: InfoSectionProps) {
  const handleLinkClick = (link: { text: string; url: string; mix_panel_title?: string | null }) => {
    trackMenuNavigation({
      button_label: link.text,
      carousel: 'no',
      category: '',
      sub_category: '',
      link: link.url,
    });
  };

  const handleChatClick = () => {
    onChatWithUsClick();
  };

  const getContactFormUrl = () => {
    const urlPrefix = country === 'CH' && language !== 'de' 
      ? `ch-${language}` 
      : country.toLowerCase();
    return `${clientConfig.FUNNEL_URL || ''}/${urlPrefix}/contact`;
  };

  const processedMenuLinks = menuLinks.map(link => ({
    ...link,
    url: link.url && link.url.includes('/contact') ? getContactFormUrl() : link.url
  }));

  return (
    <div id="info-section" className="mt-4">
      <span className="font-poppins font-medium block text-[#757575] tracking-[1px] uppercase px-5 leading-[26px] mb-2 md:px-6 md:text-[15px] pt-3 text-[13px]">
        {translator.translate(language, 'layout', 'sidebar/information')}
      </span>
      <div className="flex flex-col">
        <button
          className="flex items-center w-full cursor-pointer text-left border-none bg-transparent justify-between h-[3.375rem] md:px-6 px-5 hover:bg-[#f2f4f6]"
          style={{ transition: 'background-color 0.2s ease' }}
          onClick={handleChatClick}
          type="button"
          data-js="chat-with-us"
        >
          <span className="font-poppins font-medium text-[#1f2937] leading-[21px] text-[16px] tracking-normal">
            {translator.translate(language, 'layout', 'sidebar/chat_with_us') || translator.translate(language, 'my_account', 'my_account/chat_with_us') || 'Kontaktieren Sie uns'}
          </span>
          <img src="/img_v4/icons/chevron-right-icon.svg" alt="" aria-hidden="true" className="h-[9.33px] w-[5.33px] shrink-0" style={{ color: '#98a0af' }} />
        </button>
        
        {processedMenuLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            className="flex items-center w-full cursor-pointer text-left border-none bg-transparent no-underline h-[3.375rem] md:px-6 px-5 hover:bg-[#f2f4f6]"
            style={{ transition: 'background-color 0.2s ease', textDecoration: 'none' }}
            onClick={() => handleLinkClick(link)}
            data-button-label={link.text}
          >
            <span className="font-poppins font-medium text-[#1f2937] leading-[21px] text-[16px] tracking-normal">{link.text}</span>
          </a>
        ))}
      </div>

      <LanguageToggle 
        country={country} 
        language={language} 
        isDesktopDesign={false}
        wrapperClassName="mt-4"
        titleClassName="font-poppins font-medium block text-[#757575] tracking-[1px] uppercase px-5 leading-[26px] mb-2 md:px-6 md:text-[15px] pt-3 text-[13px]"
        itemClassName="flex items-center justify-between w-full h-[3.375rem] md:px-6 px-5 bg-transparent cursor-pointer hover:bg-[#f2f4f6]"
      />
    </div>
  );
}
